import React, { Component, useState, useEffect, Fragment } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../common/loaderapp';
import axios from 'axios';
import CKEditors from "react-ckeditor-component";
import Editor from '../common/elemts/descripcion2'

const NewsEdit = () => {
    let navigate = useNavigate();
    const { id } = useParams();
    const [load, setLoad] = useState(true);
    const [news, setNews] = useState({ title:'', subtitle:'', date:'', picture:'', content: '', archive: '', is_archive : false, is_visible:true})
    const [key, setKey] = useState(0); 
    const [keyArchive, setKeyArchive] = useState(0); 
    const [file, setFile] = useState(null);
    const [archivo, setArchivo] = useState(null);
    const [contenido_html, setContenido_html] = useState('');
    const editorData=(content)=>{
		setContenido_html(content)
        setNews(state=>{return{ ...state, content:content}})
	}

    useEffect(() => {
        if(id != 0){
            fetch('/rt_news', {
                method: 'PATCH',
                body: JSON.stringify({id}),
                headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then(res => {
				console.log('El speaker',res);
                if(res.length != 0){
                    const { TITLE_NE, SUBTITLE_NE, PICTURE_NE, CONTENT_NE, ARCHIVE_NE, IS_ARCHIVE_NE, IS_VISIBLE_NE, DATE_NE } = res.result[0];
                    
                    const fechaSolo = DATE_NE.split('T')[0];
                    setNews({ title:TITLE_NE, subtitle:SUBTITLE_NE, date:fechaSolo, picture:PICTURE_NE, content:CONTENT_NE, archive:ARCHIVE_NE, is_archive:IS_ARCHIVE_NE, is_visible:IS_VISIBLE_NE })
                    setContenido_html(CONTENT_NE)
                }
            })
            .catch(err => console.log('Error: '+err))
        }
        setLoad(false);
    }, [])

    const { title, subtitle, date, picture, content, archive, is_archive, is_visible } = news
    const actNews=(e)=>setNews({ ...news, [e.target.name]:(e.target.value)})
    
    function setInfo() {
        fetch('/rt_news', {
            method: id != 0 ? 'PUT' : 'POST',
            body: JSON.stringify({...news,id}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            console.log('El news',res);
            navigate('/news')
        })
        .catch(err => console.log('Error: '+err))
    }

    const handleFileChange = (event) => {
        console.log('FILE',event.target.files[0]);
        const selectedFile = event.target.files[0];
        if (selectedFile && !/^image\//.test(selectedFile.type)) {
            console.error('Invalid file type. Only images are allowed.');
            setKey((prevKey) => prevKey + 1);
            setFile(null);
        } else {
            setNews({ ...news, 'picture':selectedFile.name})
            setFile(selectedFile);
        }
    };

    const handleArchivoChange = (event) => {
        console.log('FILE',event.target.files[0]);
        const selectedFile = event.target.files[0];
        console.log('El tipo de file', selectedFile);
        
        setNews({ ...news, 'archive':selectedFile.name})
        setArchivo(selectedFile);
    };

    const handleUpload = async () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await axios.post('/uploadNews', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log('File uploaded successfully:', response.data);
                if(archivo){
                    handleUploadArchivo()
                }
                else{
                    setInfo();
                }
            } catch (error) {
            console.error('Error uploading file:', error);
            }
        } else {
            console.error('No file selected');
            if(archivo){
                handleUploadArchivo()
            }
            else{
                setInfo();
            }
        }
    };

    const handleUploadArchivo = async () => {
        if (archivo) {
            const formData = new FormData();
            formData.append('archivo', archivo);
            try {
                const response = await axios.post('/uploadNewsFiles', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log('archivo uploaded successfully:', response.data);
                setInfo();
            } catch (error) {
            console.error('Error uploading archivo:', error);
            }
        } else {
            console.error('No archive selected');
            setInfo()
        }
    };

    return (
        <Fragment>
            {load ? 
                <Loader/>: 
                <Fragment>
                    <div className="col-sm-12 mt-5 mb-5">
                        <div className="row">
                            <div className="col-sm-12 mb-2 mt-3">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <h5>Edit News data</h5>
                                <p>You can edit the name, photo and title, also you can add news or delete them.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12 mb-3">
                                <label>Title:</label>
                                <input className="form-control" name="title" value={title} onChange={actNews}></input>
                            </div>
                            <div className="form-group col-md-12 mb-3">
                                <label>Date:</label>
                                <input className="form-control" name="date" type="date" value={date} onChange={actNews}></input>
                            </div>
                            <div className="form-group col-md-12 mb-3">
                                <label>Subtitle:</label>
                                <input className="form-control" name="subtitle" value={subtitle} onChange={actNews}></input>
                            </div>
                            <div className="form-group col-md-12 mb-4">
                                <label className="form-label">Picture: (400x400px)</label>
                                <div className="inputUpload">
                                    <input key={key} className="form-control"  type="file"  onChange={handleFileChange}></input>
                                    <span className="inputUploadDec">Select picture <i class="fa-solid fa-upload"></i></span>
                                </div>
                            </div>

                            <div className="form-group col-md-12">
                                <label>Content news:</label>
                                {/* <textarea className="form-control" name="bio" style={{minHeight:"280px"}} value={bio} onChange={actNews}></textarea> */}
                               <div className="editor-de-texto" style={{width: '100%'}}>
                                <Editor descripcion={contenido_html} setDescripcion={editorData} />
                               </div>
                            </div>
                            <div className="form-group col-7">
                                <label className="form-label">Is Archive: </label>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={is_archive} onChange={()=>{setNews({...news, is_archive: !is_archive})}}></input>
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        Yes
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={!is_archive} onChange={()=>{setNews({...news, is_archive: !is_archive})}}></input>
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        No
                                    </label>
                                </div>
                            </div>
                            {
                                is_archive &&
                                <div className="form-group col-md-12 mb-4">
                                    <label className="form-label">Archive: </label>
                                    <div className="inputUpload">
                                        <input key={keyArchive} className="form-control"  type="file"  onChange={handleArchivoChange}></input>
                                        <span className="inputUploadDec">Select archive <i class="fa-solid fa-upload"></i></span>
                                    </div>
                                </div>
                            }
                            <div className="form-group col-md-6 mb-5">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="flexRadioDefaultVisible" id="flexRadioVisible1" checked={is_visible} onChange={()=>{setNews({...news, is_visible: !is_visible})}}></input>
                                    <label class="form-check-label" for="flexRadioVisible1">
                                        Public
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="flexRadioDefaultVisible" id="flexRadioVisible2" checked={!is_visible} onChange={()=>{setNews({...news, is_visible: !is_visible})}}></input>
                                    <label class="form-check-label" for="flexRadioVisible2">
                                        Hidden
                                    </label>
                                </div>
                            </div>
                            <div className="col-12 d-flex">
                                <button type="button" className="btn btn-primary ms-auto" onClick={handleUpload}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
}

export default NewsEdit;